import { ReactComponent as Cardiology } from "../assets/svgs/doctorTypes/CardiologyIcon.svg";
import { ReactComponent as GynecologistIcon } from "../assets/svgs/doctorTypes/GynecologistIcon.svg";
import { ReactComponent as EyeSpecialistIcon } from "../assets/svgs/doctorTypes/EyeSpecialistIcon.svg";
import { ReactComponent as SkinSpecialistIcon } from "../assets/svgs/doctorTypes/SkinSpecialistIcon.svg";
import { ReactComponent as UrologistIcon } from "../assets/svgs/doctorTypes/UrologistIcon.svg";
import { ReactComponent as GeneralPhysicianIcon } from "../assets/svgs/doctorTypes/GeneralPhysicianIcon.svg";
import { ReactComponent as ENTSpecialistIcon } from "../assets/svgs/doctorTypes/ENTSpecialistIcon.svg";
import { ReactComponent as GastroenterologistIcon } from "../assets/svgs/doctorTypes/GastroenterologistIcon.svg";
import { ReactComponent as PsychologistIcon } from "../assets/svgs/doctorTypes/PsychologistIcon.svg";
import { ReactComponent as DentistIcon } from "../assets/svgs/doctorTypes/DentistIcon.svg";
import { ReactComponent as ClinicalDieticianIcon } from "../assets/svgs/doctorTypes/ClinicalDieticianIcon.svg";
import { ReactComponent as PediatricianIcon } from "../assets/svgs/doctorTypes/PediatricianIcon.svg";
import { ReactComponent as PhysiotherapistIcon } from "../assets/svgs/doctorTypes/PhysiotherapistIcon.svg";
import { ReactComponent as GeneralSurgeonIcon } from "../assets/svgs/doctorTypes/GeneralSurgeonIcon.svg";
import { ReactComponent as VenerologistIcon } from "../assets/svgs/doctorTypes/VenerologistIcon.svg";
import { ReactComponent as OrthopedicIcon } from "../assets/svgs/doctorTypes/OrthopedicIcon.svg";

export const doctorSpecialties = [
  { name: "Cardiology", Icon: Cardiology },
  { name: "Gynecology", Icon: GynecologistIcon },
  { name: "Eye Specialist", Icon: EyeSpecialistIcon },
  { name: "Skin Specialist", Icon: SkinSpecialistIcon },
  { name: "Urologist", Icon: UrologistIcon },
  { name: "General Physician", Icon: GeneralPhysicianIcon },
  { name: "ENT Specialist", Icon: ENTSpecialistIcon },
  { name: "Gastroenterologist", Icon: GastroenterologistIcon },
  { name: "Psychologist", Icon: PsychologistIcon },
  { name: "Dentist", Icon: DentistIcon },
  { name: "Clinical Dietician", Icon: ClinicalDieticianIcon },
  { name: "Pediatrician", Icon: PediatricianIcon },
  { name: "Orthopedic", Icon: OrthopedicIcon },
  { name: "Physiotherapist", Icon: PhysiotherapistIcon },
  { name: "General Surgeon", Icon: GeneralSurgeonIcon },
  { name: "Venerologist", Icon: VenerologistIcon },
];
